import PATH from '../paths';

const name = 'Millennials And Wealth';
const key = 'millennials';
const imgUrl = `${ PATH.CDN }/whitelabels/${ key }`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/logo.svg`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  logoSidebar: `${ imgUrl }/logo-sidebar.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/background.jpg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-millennials-orange:       #f47823;
    --color-millennials-black:        #000000;
    --color-millennials-blueLight:           #818a91;

    --color-primary:                  var(--color-millennials-orange);
    --color-secondary:                var(--color-millennials-black);
    --color-accent:                   var(--color-white);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-millennials-orange);
    --color-link-hover:               var(--color-darker);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              transparent;
    --anonymous-copy-bg:              var(--color-millennials-black);
    --anonymous-heading-color:        var(--color-white);
    --anonymous-subheading-color:     var(--color-white);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          70px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-millennials-black);
    --sidebar-logo-bg-color: #022b42
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color-millennials-blueLight);

    --sidebar-button-color: var(--color-accent);
    --sidebar-button-color-active: var(--color-white);
    --sidebar-button-color-hover: var(--color-millennials-black);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-millennials-orange);
    --sidebar-button-bg-color-hover: var(--color-accent);
    --sidebar-button-border-color: var(--color-accent);
    --sidebar-button-border-color-active: var(--color-millennials-orange);
    --sidebar-button-border-color-hover: var(--color-accent);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-millennials-orange);
    --btn-primary--border:            var(--color-millennials-orange);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-millennials-black);
    --btn-primary--borderH:           var(--color-millennials-black);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-millennials-orange);
    --btn-secondary--color:           var(--color-millennials-black);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-millennials-black);
    --btn-secondary--colorH:          var(--color-millennials-black);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
